import { render, staticRenderFns } from "./SavedDesigns.vue?vue&type=template&id=2695a695&scoped=true&"
import script from "./SavedDesigns.vue?vue&type=script&lang=js&"
export * from "./SavedDesigns.vue?vue&type=script&lang=js&"
import style0 from "./SavedDesigns.vue?vue&type=style&index=0&id=2695a695&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2695a695",
  null
  
)

export default component.exports